import React, { useState, useEffect, useCallback } from "react";
import { NotificationManager } from "react-notifications";
import { hideLoader, showLoader } from "../../utils/loader";
import { customBaseUrl, httpGet, httpPost } from "../../store/http";
import Layout from "../../components/Layout";
import { Button, Tabs } from "antd";
import PinModal from "../../components/Modal/Pin/PinModal";
import AntTable from "../../components/CustomTable/AntTable";
import { useNavigate } from "react-router-dom";

const { TabPane } = Tabs;

const Disbursement = () => {
    const navigate = useNavigate();
    const [isOtpVerified, setIsOtpVerified] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [otp, setOtp] = useState("");
    const [data, setData] = useState([]);
    const [disbursedLoans, setDisbursedLoans] = useState([]);
    const [activeTab, setActiveTab] = useState("readyForDisbursement");

    const getLoans = useCallback(async () => {
        showLoader();
        const res = await httpGet(`${customBaseUrl.loanUrl}/api/v1/loans/ready-for-disbursement`);
        if (res.status) {
            setData(res.data);
            hideLoader();
        } else {
            hideLoader();
            NotificationManager.error(res.message);
        }
    }, []);

    const getDisbursedLoans = useCallback(async () => {
        showLoader();
        const res = await httpGet(`${customBaseUrl.loanUrl}/api/v1/loans/disbursed-with-payments`);
        if (res.status) {
            setDisbursedLoans(res.data);
            hideLoader();
        } else {
            hideLoader();
            NotificationManager.error(res.message);
        }
    }, []);

    const handleApprove = async (record) => {
        showLoader();
        const res = await httpPost(
            `${customBaseUrl.loanUrl}/api/v1/loans/${record.loan_id}/disburse`
        );
        if (res.status) {
            NotificationManager.success("Loan disbursed successfully");
            hideLoader();
            getLoans();
        } else {
            hideLoader();
            NotificationManager.error(res.message);
        }
    }

    const columns = [
        {
            title: "Loan ID",
            dataIndex: "loan_id",
            key: "loan_id",
        },
        {
            title: "Type",
            dataIndex: "type",
            key: "type",
        },
        {
            title: "Amount",
            dataIndex: "amount",
            key: "amount",
        },
        {
            title: "First Name",
            dataIndex: "first_name",
            key: "first_name",
        },
        {
            title: "Last Name",
            dataIndex: "last_name",
            key: "last_name",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
        },
        {
            title: "Action",
            key: "action",
            render: (text, record) => (
                <Button type="primary" onClick={() => handleApprove(record)}>
                    Approve
                </Button>
            ),
        },
    ];

    const disbursedColumns = [
        {
            title: "Loan ID",
            dataIndex: "loan_id",
            key: "loan_id",
        },
        {
            title: "Type",
            dataIndex: "type",
            key: "type",
        },
        {
            title: "Amount",
            dataIndex: "amount",
            key: "amount",
        },
        {
            title: "Loan Start Date",
            dataIndex: "loan_start_date",
            key: "loan_start_date",
        },
        {
            title: "Loan End Date",
            dataIndex: "loan_end_date",
            key: "loan_end_date",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
        },
        {
            title: "First Name",
            dataIndex: "first_name",
            key: "first_name",
        },
        {
            title: "Last Name",
            dataIndex: "last_name",
            key: "last_name",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
        },
    ];

    const handleOtp = async () => {
        if (otp === "") {
            return NotificationManager.error("OTP is required");
        }
        showLoader();
        const res = await httpGet(
            `${customBaseUrl.loanUrl}/api/v1/admin/verify-otp/owner?otp=${Number(otp)}`
        );
        if (res.status) {
            NotificationManager.success("OTP verified successfully");
            hideLoader();
            setIsOtpVerified(true);
            setIsModalVisible(false);
        } else {
            hideLoader();
            NotificationManager.error(res.message);
        }
    }

    const sendOTP = useCallback(async () => {
        showLoader();
        const res = await httpPost(
            `${customBaseUrl.loanUrl}/api/v1/admin/send-otp/owner`,
            { email: localStorage.getItem('email') }
        );
        if (res.status === true) {
            NotificationManager.success("OTP sent");
            hideLoader();
            setIsModalVisible(true);
        } else {
            hideLoader();
            NotificationManager.error(res.message);
        }
    }, []);

    useEffect(() => {
        const roles = localStorage.getItem('roles');
        if (roles?.includes('ROLE_OWNER') || roles?.includes('ROLE_SUPER')) {
            sendOTP();
        } else {
            navigate(-1);
        }
    }, [navigate, sendOTP]);

    useEffect(() => {
        if (isOtpVerified) {
            getLoans();
            getDisbursedLoans();
        }
    }, [isOtpVerified, getLoans, getDisbursedLoans]);

    return (
        <Layout>
            {isOtpVerified ? <div>
                <h1>Loan Disbursement</h1>
                <Tabs defaultActiveKey="readyForDisbursement" activeKey={activeTab} onChange={setActiveTab}>
                    <TabPane tab="Ready for Disbursement" key="readyForDisbursement">
                        <AntTable columns={columns} dataSource={data} />
                    </TabPane>
                    <TabPane tab="Disbursed Loans" key="disbursedLoans">
                        <AntTable columns={disbursedColumns} dataSource={disbursedLoans} />
                    </TabPane>
                </Tabs>
            </div>
                : <PinModal

                    showModal={isModalVisible}
                    hideModal={setIsModalVisible}
                    otp={otp}
                    setOtp={setOtp}
                    numInputs={6}
                    separator=''
                    buttonLabel='Verify'
                    title='Verify OTP'
                    description='Please input the OTP sent to your Phone'
                    pinMode={true}
                    handleSubmit={handleOtp}

                />}
        </Layout>
    )
}

export default Disbursement;
